import React, { useState, useMemo } from 'react';
import { HashRouter as Router } from 'react-router-dom';

import { version } from './MetaVariables'; // Assuming this file exists and exports version
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider as CustomThemeProvider } from './theme/ThemeContext'; // Renamed ThemeProvider import
// import ThemeToggle from './components/common/ThemeToggle'; // Moved to AppContent
import { ProfileProvider } from './contexts/ProfileContext';
import { LoadingStatusProvider } from './contexts/LoadingStatusContext';
import AppContent from './AppContent'; // Import the new AppContent component

// Helper function to get URL parameters
export function GetURLParameter(sParam: string): string | null {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');
  for (var i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      // Use decodeURIComponent instead of decodeURI for potentially encoded values
      return decodeURIComponent(sParameterName[1]);
    }
  }
  return null;
}

// Helper function to get basename from URL
export function getBasename(): string {
  // Check if there's a pathname before the last slash that isn't just '/'
  const pathname = window.location.pathname;
  const lastSlashIndex = pathname.lastIndexOf('/');

  if (lastSlashIndex <= 0) {
    return ''; // No basename or just root
  }

  // Get everything before the last segment
  return pathname.substring(0, lastSlashIndex);
}

// Moved from AppContent.tsx as it's used here for props
export const getBusinessDates = (startDate: Date | string, count: number): string[] => {
    const dates: string[] = [];
    let currentDate = new Date(startDate);

    while (dates.length < count) {
      const formattedDate = currentDate.toISOString().split('T')[0];
      // Check if it's not Sunday (0) or Saturday (6)
      if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
        dates.push(formattedDate);
      }
      currentDate.setDate(currentDate.getDate() - 1); // Move to the previous day
    }
    return dates;
};


// Wrap your AppContent with LoadingStatusProvider and ApiProvider
const NewApp: React.FC = () => {
  const [localhost] = useState<string | null>(GetURLParameter('localhost'));
  const [urlPrimaryBase] = useState<string>(
    // localhost ? `http://${localhost}:5000/` : 'https://stockleaders.io/insightsfast/'
    localhost ? `http://${localhost}:5000/` : 'https://seattlemarketanalytics.ai/insightsfast/'
  );

  // Get basename for the router
  const basename = useMemo(() => getBasename(), []);

  console.log('NewApp: URL Primary Base:', urlPrimaryBase);
  console.log('NewApp: Localhost:', localhost);
  console.log('NewApp: Version:', version); // Log version

  return (
    // Use basename="" if deploying to root, or the calculated basename
    <Router basename={basename || ""}>
      <LoadingStatusProvider>
        <AuthProvider baseUrl={urlPrimaryBase}>
          <CustomThemeProvider> {/* Use renamed ThemeProvider */}
            <ProfileProvider>
              <AppContent
                urlPrimaryBase={urlPrimaryBase}
                getBusinessDates={getBusinessDates} // Now correctly passed as a prop
              />
            </ProfileProvider>
          </CustomThemeProvider>
        </AuthProvider>
      </LoadingStatusProvider>
    </Router>
  );
};

export default NewApp;
